import { render, staticRenderFns } from "./ProvinceDrawer.vue?vue&type=template&id=4a851268&scoped=true"
import script from "./ProvinceDrawer.vue?vue&type=script&lang=js"
export * from "./ProvinceDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProvinceDrawer.vue?vue&type=style&index=0&id=4a851268&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a851268",
  null
  
)

export default component.exports